export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const API_KEY = '87521168-a2dc-4049-8064-a6c31f5f81bc';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 1;
